<template>
    <ies-form-field :field="field">
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            label="Payee"
            :items="payeeOptions"
            autocomplete
        ></v-autocomplete>

        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>

<script>
    /**
     * Allows the setting of a hotel additional fee payee from a list of
     * options
     */
    export default {
        name: 'ies-fee-payee',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                payeeOptions: [{text: "None - included in quote", value: 1}, {text: "Fee added to quote", value: 2}, {text: "Paid directly to the property", value: 3}, {text: "Unknown - property to confirm", value: 4}],
                viewValue: parseInt(this.field.value),
            }
        },

        methods: {
            updateField:function(){
                console.log(this.viewValue);
                this.getRelatedRecordType();
            }
        },

        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
console.log(this.field.value);
            }
        },
    }
</script>
